module.exports = __webpack_public_path__ + "img/submittedSuces.a0315666.svg";